<script setup lang="ts">
import { GameKeyEnum } from '@/types/enums'

const { logOut, showLogInDialog, isLogged, routeGame, isLoggedGoat, getGameTokens } = gamesUtils
const { isDesktop } = tools
const { gaSections } = gaUtils
const { t } = useI18n()

const isConnected = computed(() => {
  if (!routeGame.value?.id) {
    return Object.entries(getGameTokens()).some(([keyOfGame, tokenData]) => {
      if (keyOfGame === GameKeyEnum.goat) {
        return false
      }
      return tokenData?.token?.length > 0
    })
  } else {
    return isLogged.value
  }
})
</script>

<template>
  <div class="login-btn-component">
    <transition
      name="el-fade-in-linear"
      mode="out-in"
    >
      <template v-if="!isLogged && !isLoggedGoat">
        <div class="inline-flex items-center justify-center">
          <el-button
            color="#1b5862"
            class="text-white rounded-lg uppercase relative ease-in-out duration-700 overflow-hidden big:h-9 not-default"
            size="large"
            v-bind="$attrs"
            @click="showLogInDialog(true, { gs_game: routeGame?.gameKey, gs_route: String($route.name), gs_section: gaSections.btnLogin })"
          >
            <div class="text-base tracking-wide pl-10 font-black">
              {{ t('logInBanner.logIn') }}
              <div
                v-if="routeGame?.icon"
                class="absolute left-0 top-0 bottom-0 w-10 big:w-9 p-0 flex items-center"
              >
                <el-image
                  :src="routeGame.icon"
                  class="max-h-full gs-disable-placeholder"
                />
              </div>
            </div>
          </el-button>
        </div>
      </template>
      <template v-else-if="isLoggedGoat">
        <template v-if="routeGame?.gameKey">
          <div v-if="isDesktop">
            <div class="rounded-2xl p-2 big:p-1 bg-[#0a343d] text-white">
              <div class="flex justify-between items-center">
                <div class="flex items-center justify-start">
                  <el-popover
                    placement="bottom"
                    :show-after="300"
                    :offset="20"
                    width="auto"
                    popper-class="rounded-2xl border-none"
                    popper-style="--el-bg-color-overlay: #0a343d"
                  >
                    <template #reference>
                      <div
                        :class="{ 'min-w-44': isConnected, 'min-w-36 xl:min-w-44': !isConnected }"
                      >
                        <div class="flex items-center  grow lg:max-w-max">
                          <player-avatar
                            v-if="isConnected"
                            :game-key="routeGame?.gameKey"
                            logo-game
                            hide-avatar
                            :with-league-icon="false"
                            size-game-icon="w-7"
                            class="text-base"
                          />
                          <goat-avatar-section
                            v-else
                            :game-key="routeGame?.gameKey"
                            class="text-base"
                            size="w-7"
                            :section="gaSections.header"
                          />
                        </div>
                      </div>
                    </template>
                    <template #default>
                      <div class="px-3 min-w-96">
                        <div class="grid grid-cols-[1fr_auto] gap-2 text-white">
                          <template v-if="isConnected">
                            <player-avatar
                              :game-key="routeGame?.gameKey"
                              logo-game
                              hide-avatar
                              with-league-icon
                              size-game-icon="w-8 py-1"
                              class="text-lg"
                            />
                          </template>
                          <template v-else>
                            <goat-avatar-section
                              :game-key="routeGame?.gameKey"
                              class="text-lg"
                              size="w-8"
                              section="gaSections.header"
                            />
                          </template>
                          <el-button
                            link
                            size="default"
                            class="not-default:"
                            @click="logOut(GameKeyEnum.goat)"
                          >
                            <div class="text-xs tracking-wide underline underline-offset-2 whitespace-nowrap text-white">
                              {{ t('goatUserBox.logOut') }}
                              <icon-ify
                                icon="ion:log-out-outline"
                                class="text-lg inline-block"
                              />
                            </div>
                          </el-button>
                        </div>
                        <div class="w-full mt-2 flex justify-center">
                          <goat-manage-account-btn />
                        </div>
                      </div>
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <template v-else>
            <div
              class="bg-[#041a1f] py-5"
            >
              <div class="px-2 mx-auto max-w-[min(450px,98vw)]">
                <div class="grid grid-cols-[1fr_auto] gap-2 text-white">
                  <template v-if="isConnected">
                    <player-avatar
                      :game-key="routeGame?.gameKey"
                      logo-game
                      hide-avatar
                      with-league-icon
                      size-game-icon="w-8 py-1"
                      class="text-lg"
                    />
                  </template>
                  <template v-else>
                    <goat-avatar-section
                      :game-key="routeGame?.gameKey"
                      class="text-lg"
                      size="w-8"
                      section="gaSections.header"
                    />
                  </template>
                  <el-button
                    link
                    size="default"
                    class="not-default"
                    @click="logOut(GameKeyEnum.goat)"
                  >
                    <div class="text-xs tracking-wide underline underline-offset-2 whitespace-nowrap text-white">
                      {{ t('goatUserBox.logOut') }}
                      <icon-ify
                        icon="ion:log-out-outline"
                        class="text-lg inline-block"
                      />
                    </div>
                  </el-button>
                </div>
                <div class="w-full mt-2 flex justify-center">
                  <goat-manage-account-btn />
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>
      <div
        v-else
      >
        <template v-if="routeGame?.gameKey">
          <div v-if="isDesktop">
            <div class="rounded-2xl p-2 big:p-1 bg-[#0a343d] text-white">
              <div class="flex justify-between items-center">
                <div class="flex items-center justify-start">
                  <el-popover
                    placement="bottom"
                    :show-after="300"
                    :offset="20"
                    width="auto"
                    popper-class="rounded-2xl border-none"
                    popper-style="--el-bg-color-overlay: #0a343d"
                  >
                    <template #reference>
                      <div
                        class="min-w-44"
                      >
                        <div class="flex items-center  grow lg:max-w-max">
                          <player-avatar
                            :game-key="routeGame?.gameKey"
                            logo-game
                            hide-avatar
                            :with-league-icon="false"
                            size-game-icon="w-7"
                            class="text-base"
                          />
                        </div>
                      </div>
                    </template>
                    <template #default>
                      <div class="px-3 min-w-96">
                        <div class="grid grid-cols-[1fr_auto] gap-2 text-white">
                          <player-avatar
                            :game-key="routeGame?.gameKey"
                            logo-game
                            hide-avatar
                            with-league-icon
                            size-game-icon="w-8 py-1"
                            class="text-lg"
                          />
                          <el-button
                            link
                            size="default"
                            class="not-default"
                            @click="logOut(routeGame?.gameKey)"
                          >
                            <div class="text-xs tracking-wide underline underline-offset-2 whitespace-nowrap text-white">
                              {{ t('goatUserBox.logOut') }}
                              <icon-ify
                                icon="ion:log-out-outline"
                                class="text-lg inline-block"
                              />
                            </div>
                          </el-button>
                        </div>
                      </div>
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <template v-else>
            <div
              class="bg-[#041a1f] py-5"
            >
              <div class="px-2 mx-auto  max-w-[min(450px,98vw)]">
                <div class="grid grid-cols-[1fr_auto] gap-2 text-white">
                  <player-avatar
                    :game-key="routeGame?.gameKey"
                    logo-game
                    hide-avatar
                    with-league-icon
                    size-game-icon="w-8 py-1"
                    class="text-lg"
                  />
                  <el-button
                    link
                    size="default"
                    class="not-default"
                    @click="logOut(routeGame?.gameKey)"
                  >
                    <div class="text-xs tracking-wide underline underline-offset-2 whitespace-nowrap text-white">
                      {{ t('goatUserBox.logOut') }}
                      <icon-ify
                        icon="ion:log-out-outline"
                        class="text-lg inline-block"
                      />
                    </div>
                  </el-button>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </transition>
  </div>
</template>

<style scoped lang="postcss">
.el-button:hover {
  .el-image {
    opacity: 0.5;
  }
}
</style>
